class ArrayHelpers {
  removeDuplicateCustomers = (data, uniqueLabel) => {
    // Create an object to store unique field value
    const uniqueRecordsMap = {};

      // Filter out duplicates based on the field value
      const uniqueRecords = data.filter((record) => {
        if (!uniqueRecordsMap[record[uniqueLabel]]) {
          // If field value is not encountered before, mark it as encountered
          uniqueRecordsMap[record[uniqueLabel]] = true;
          return true;
        }
        return false;
      });
      return uniqueRecords;
    }
}
export default new ArrayHelpers();
